import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../components/page-title.tsx';
import { TaskDialogListener } from '../../features/tasks/components/task-dialog-listener.tsx';
import { useTaskOverviewColumns } from '../../features/tasks/hooks/use-task-overview-columns.tsx';
import { TaskOverviewPage } from '../../features/tasks/page/task-overview-page.tsx';

export function useTasksAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    const todayColumns = useTaskOverviewColumns('today');
    const completedColumns = useTaskOverviewColumns('completed');
    const columns = useMemo(() => [...todayColumns, ...completedColumns], [todayColumns, completedColumns]);

    return usePageAiMeta(
        {
            path: '/tasks',
            title: t('page_title__tasks', { ns: 'common' }),
            description:
                "The user's tasks grouped into today, overdue tasks included, upcoming and completed, " +
                'with due date, related customer, order or quote, assignee, creator and attachments. ' +
                'Send the user here to create, complete or edit a task, including changing its assignee ' +
                'in the task details. When creating a task, the user can pick several assignees at once ' +
                'and each of them gets their own copy of the task with the same title, due date and ' +
                'links.',
        },
        columns,
    );
}

function TasksPage() {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle title={t('page_title__tasks')} />
            <TaskOverviewPage />
            <TaskDialogListener />
        </>
    );
}

export default TasksPage;
